// Generated by CoffeeScript 1.12.7
(function () {
  var EntityData,
    bind = function (fn, me) {
      return function () {
        return fn.apply(me, arguments);
      };
    };

  module.exports = EntityData = (function () {
    function EntityData($http, apiBaseUrl, accountId, currencies) {
      this.apiBaseUrl = apiBaseUrl;
      this.accountId = accountId;
      this.currencies = currencies;
      this.getQuotes = bind(this.getQuotes, this);
      this.getProjectCountsByDate = bind(this.getProjectCountsByDate, this);
      this.getProjectCounts = bind(this.getProjectCounts, this);
      this.http = $http;
    }

    EntityData.prototype.getProjectCounts = function () {
      return this.http.get(this.apiBaseUrl + "/accounts/" + this.accountId + "/dataset/pages");
    };

    EntityData.prototype.getProjectCountsByDate = function () {
      return this.http.get(this.apiBaseUrl + "/accounts/" + this.accountId + "/dataset/pages-by-date");
    };

    EntityData.prototype.getQuotes = function () {
      return this.http.get(this.apiBaseUrl + "/accounts/" + this.accountId + "/dataset/quotes").then(
        (function (_this) {
          return function (data) {
            var ref, status, totals, totalsByCurrency;
            totals = {};
            ref = data.data;
            for (status in ref) {
              totalsByCurrency = ref[status];
              totals[status] = _.map(totalsByCurrency, function (total, currencyCode) {
                var currency;
                currency = _.find(_this.currencies, {
                  code: currencyCode,
                });
                if (currency == null) {
                  throw new Error("Currency " + currencyCode + " is not defined");
                }
                return {
                  value: total,
                  currency: currency,
                };
              });
            }
            return totals;
          };
        })(this),
      );
    };

    return EntityData;
  })();
}.call(this));
